import { planTypes } from '@/common/constants';
import { UpdateTypes } from '@/common/service/checkout-utils';
import { getAudioCountriesParams } from '@/common/service/flow/utils';
import { isDIDPlan } from '@/plans/TOLLFREE$DID/common';
import store from '@/store';
import { plansof } from '@/utils/chain';
import { isOnlineNotSupportPlan } from "@/common/service/non-standard-billing-cycle-utils";

export function getDIDPlanSubscriptions(subscriptions, planMapFlat) {
  const DIDPlan = planMapFlat.find(isDIDPlan);
  if (!DIDPlan) return [];

  return subscriptions
    .filter((subs) => subs.tollfree_apac_hosts > 0 && !subs.tollfree_apac_cancelled)
    .reduce((acc, subs) => {
      acc.push({
        assignedCount: 0,
        billingCycle: DIDPlan.billing_cycle,
        cancelled: subs.tollfree_apac_cancelled,
        category: DIDPlan.category,
        couponDiscountType: subs.tollfree_apac_couponDiscountType,
        discount: subs.tollfree_apac_discount,
        expire_date: subs.tollfree_apac_expire_date,
        hasUndoChange: false,
        has_decrease_request: false,
        has_downgrade_request: false,
        has_same_pending_plan: false,
        isFreeTrial: subs.isFreeTrial,
        isOnlineFreeTrial: subs.isOnlineFreeTrial,
        mapCode: '',
        mapPaidCode: '',
        parentCategory: subs.parentCategory,
        planExpireTime: subs.tollfree_apac_planExpireTime,
        planStartTime: subs.tollfree_apac_planStartTime,
        plan_code: DIDPlan.plan_code,
        price: subs.tollfree_apac_price,
        price_mapping_plan_code: '',
        quantity: subs.tollfree_apac_hosts,
        tollfree_apac_hosts: subs.tollfree_apac_hosts,
        tollfree_apac_cancelled: subs.tollfree_apac_cancelled,
        tollfree_apac_isOnlineCancel: subs.tollfree_apac_isOnlineCancel,
      });
      return acc;
    }, []);
}

export function getBoughtTollFree(boughtPlans) {
  return plansof(boughtPlans).type(planTypes.TOLLFREE, planTypes.TOLLFREE$DID).get();
}

export function getTollFreeUpdateForm({ boughtPlans, getSelectedPlans }) {
  const planList = [];
  const selectedTollFree = plansof(getSelectedPlans).type(planTypes.TOLLFREE, planTypes.TOLLFREE$DID).get();
  const boughtTollFree = getBoughtTollFree(boughtPlans);
  // Edited/Added plan
  selectedTollFree.forEach((plan) => {
    const boughtPlan = boughtTollFree.find(
      (p) => p.plan_code === plan.plan_code || (p.type === plan.type && p.category === plan.category),
    );
    let extraKeys = {}
    if (isOnlineNotSupportPlan({ planType: plan.type, billingCycle: plan.billing_cycle, category: plan.category })) {
      boughtPlan?.plan_type && Object.assign(extraKeys, { oldPlanType: boughtPlan.plan_type })
      plan?.plan_type && Object.assign(extraKeys, { planType: plan.plan_type })
    }
    planList.push({
      oldPlanCode: boughtPlan ? boughtPlan.plan_code : '',
      planCode: plan.plan_code,
      quantity: plan.cartInfo.selected_number,
      ...extraKeys
    });
  });
  // Deleted plan
  boughtTollFree.forEach((plan) => {
    if (planList.every((p) => p.oldPlanCode !== plan.plan_code)) {
      planList.push({ oldPlanCode: plan.plan_code, planCode: plan.plan_code, quantity: 0 });
    }
  });

  const selectedDIDPlan = selectedTollFree.find(isDIDPlan);
  const tollfreeAPACHosts = selectedDIDPlan ? selectedDIDPlan.cartInfo.selected_number : 0;

  return {
    planList,
    actionType: UpdateTypes.UPDATE_TOLL_FREE,
    extensionUpdateData: {
      tollFreeProfileData: getAudioCountriesParams(store),
      tollfreeAPACHosts,
      isAPACChecked: selectedDIDPlan ? 1 : 0,
    },
  };
}

export function syncBoughtTollFreeInfo2Cart(boughtPlan, planMapFlat) {
  const {
    plan_code,
    plan_type,
    cartInfo: { tollFreeProfileData },
  } = boughtPlan;
  if (tollFreeProfileData) {
    let found = null
    if (plan_type) {
      found = planMapFlat.find((p) => p.plan_type === plan_type);
    } else {
      found = planMapFlat.find((p) => p.plan_code === plan_code);
    }
    if (found) found.cartInfo.tollFreeProfileData = tollFreeProfileData;
  }
}
